import { render, staticRenderFns } from "./RatingSelector.vue?vue&type=template&id=812df304&scoped=true&"
import script from "./RatingSelector.vue?vue&type=script&lang=js&"
export * from "./RatingSelector.vue?vue&type=script&lang=js&"
import style0 from "./RatingSelector.vue?vue&type=style&index=0&id=812df304&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812df304",
  null
  
)

export default component.exports